import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL + "auth/";

class AuthService {
  async login(user) {
    try {
      const response = await axios
        .post(API_URL + 'login', {
          email: user.email,
          password: user.password
        });
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data?.error);
    }
  }

  logout() {
    localStorage.removeItem('user');
  }

  async register(user) {
    try {
      const response = await axios.post(API_URL + 'register', {
        email: user.email,
        password: user.password,
        first_name: user.first_name,
        last_name: user.last_name,
        company: user.company,
        phone_number: user.phone_number,
      });
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data?.message ?? e.response?.data?.error);
    }
  }

  async createUser(user, token) {
    try {
      const headers = {
        "Authorization": `Bearer ${token}`
      }
      const response = await axios.post(API_URL + 'create-user', {
        email: user.email,
        password: user.password,
        first_name: user.first_name,
        last_name: user.last_name,
        company: user.company,
        phone_number: user.phone_number,
        id_role: user.id_role,
      }, { headers });
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data?.error ?? e.response?.data?.errors[0].msg ?? "Une erreur interne est survenue.");
    }
  }

  async sendMailForResetPassword(email) {
    try {
      const response = await axios
        .post(API_URL + 'send-forgot-password-token', {
          email
        });
      return response?.data.message;
    } catch (e) {
      return Promise.reject(e.response?.data?.error);
    }
  }

  async checkTokenValidity(token) {
    try {
      await axios
        .post(API_URL + 'check-forgot-password-token-validity', {
          token
        });
      return true;
    } catch (e) {
      return false;
    }
  }

  async changePassword(password, token) {
    try {
      const response = await axios
        .post(API_URL + 'change-password', {
          password,
          token
        });
      return response?.data?.token;
    } catch (e) {
      return Promise.reject(false);
    }
  }

}
export default new AuthService();